var _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7, _path8, _rect, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJournalLines({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 72,
    viewBox: "0 0 51 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1H47C48.6569 1 50 2.34315 50 4V59.541C50 61.1979 48.6568 62.541 47 62.541H8C4.13402 62.541 1.00002 59.407 1 55.541V8C1 4.13401 4.13401 1 8 1Z",
    fill: "#CCE5FF",
    stroke: "#28345A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3113 1.67212H47.3277C48.4322 1.67212 49.3277 2.56755 49.3277 3.67212V55.1803H44.3113V1.67212Z",
    fill: "#027BC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.67212 6.67212C1.67212 3.9107 3.9107 1.67212 6.67212 1.67212H13.377V55.1803H1.67212V6.67212Z",
    fill: "#027BC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.67212 56.4942C1.67212 52.5363 4.88057 49.3279 8.8384 49.3279H49.3279V59.8689C49.3279 60.9734 48.4324 61.8689 47.3279 61.8689H7.04682C4.07845 61.8689 1.67212 59.4625 1.67212 56.4942Z",
    fill: "#DADFF3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.606 25.7375C32.606 23.5284 34.3968 21.7375 36.606 21.7375H49.3273V32.6064H36.606C34.3968 32.6064 32.606 30.8155 32.606 28.6064V25.7375Z",
    fill: "#28345A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5082,
    cy: 2.5082,
    r: 2.5082,
    transform: "matrix(-1 0 0 1 40.1311 24.6638)",
    fill: "#DADFF3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19702 52.672C9.19702 52.2103 9.57134 51.8359 10.0331 51.8359H45.1478C45.6096 51.8359 45.9839 52.2103 45.9839 52.672C45.9839 53.1337 45.6096 53.5081 45.1478 53.5081H10.0331C9.57134 53.5081 9.19702 53.1337 9.19702 52.672Z",
    fill: "#28345A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19702 56.0165C9.19702 55.5547 9.57134 55.1804 10.0331 55.1804H45.1478C45.6096 55.1804 45.9839 55.5547 45.9839 56.0165C45.9839 56.4782 45.6096 56.8526 45.1478 56.8526H10.0331C9.57134 56.8526 9.19702 56.4782 9.19702 56.0165Z",
    fill: "#28345A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19702 59.3607C9.19702 58.899 9.57134 58.5247 10.0331 58.5247H45.1478C45.6096 58.5247 45.9839 58.899 45.9839 59.3607C45.9839 59.8225 45.6096 60.1968 45.1478 60.1968H10.0331C9.57134 60.1968 9.19702 59.8225 9.19702 59.3607Z",
    fill: "#28345A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.8691,
    y: 56.8525,
    width: 5.01639,
    height: 11.7049,
    fill: "#28345A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3773 64.377L16.9976 69.3933H9.75708L13.3773 64.377Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournalLines);
export default __webpack_public_path__ + "static/media/journalLines.1e53e4fc22315bb84e63f2e68cd6aa2a.svg";
export { ForwardRef as ReactComponent };